module.exports = __webpack_public_path__ + "img/lagrange_aria_ost.b09e384d.png";